/* eslint-disable @typescript-eslint/only-throw-error -- redirect é o contrato do TanStack Router */
import { createFileRoute, redirect } from '@tanstack/react-router';

// A aba do legado era caminho (router.tsx); aqui é `?tab=` (S29).
export const Route = createFileRoute('/_app/pessoas-juridicas/todas/$personId/signatarios')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/pessoas-juridicas/todas/$personId', params, search: { tab: 'signatarios' } });
  },
});
